import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "src/redux/hooks";
/**
 * Custom hook to restrict access to a page based on provided parameters.
 *
 * @param parameters - An array of boolean values. If any value is `true`, the user is redirected.
 * @returns void
 */
const useRestricted = (parameters: boolean[]) => {
  const navigate = useNavigate();
  const { hasFetchedPerms } = useSelector(state => state.permsSlice);

  useEffect(() => {
    if (parameters.includes(true) || !hasFetchedPerms) {
      navigate("/management");
    }
  }, [parameters, navigate, hasFetchedPerms]);
};
export default useRestricted;
